import instance from "@store/middleware/api";

import { IError } from "@models/inner-models";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPageCount } from "@utils/handleResponseHeaders";

import { TGetAllQuickFiltersCategoriesParams } from "./types";

enum EQuickFilters {
  GetQuickFilter = "GET_QUICK_FILTERS",
  GetQuickFiltersCategories = "GET_QUICK_FILTERS_CATEGORIES",
  GetQuickFiltersCategoriesFilterButtons = "GET_QUICK_FILTERS_CATEGORIES_FILTER_BUTTONS",
}

const BASE_URL_QUICK_FILTERS = "/quick-filters";
const BASE_URL_QUICK_FILTERS_CATEGORIES = "/quick-filters-categories";

export const quickFilterById = createAsyncThunk(EQuickFilters.GetQuickFilter, async (id: string | number, thunkAPI) => {
  try {
    const resp = await instance.get(`${BASE_URL_QUICK_FILTERS}/slug/${id}`);

    return resp.data;
  } catch (err) {
    console.log("error", err);
    const error = err as IError;
    return thunkAPI.rejectWithValue(error);
  }
});

export const quickFiltersCategories = createAsyncThunk(
  EQuickFilters.GetQuickFiltersCategories,
  async (filter: TGetAllQuickFiltersCategoriesParams, thunkAPI) => {
    try {
      const resp = await instance.get(BASE_URL_QUICK_FILTERS_CATEGORIES, {
        params: filter,
      });

      return { data: resp.data, pageCount: getPageCount(resp.headers["content-range"], filter.limit) };
    } catch (err) {
      console.log("error", err);
      const error = err as IError;
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const categoriesFilterButtons = createAsyncThunk(
  EQuickFilters.GetQuickFiltersCategoriesFilterButtons,
  async (filter: TGetAllQuickFiltersCategoriesParams, thunkAPI) => {
    try {
      const resp = await instance.get(BASE_URL_QUICK_FILTERS_CATEGORIES, {
        params: filter,
      });

      return resp.data;
    } catch (err) {
      console.log("error", err);
      const error = err as IError;
      return thunkAPI.rejectWithValue(error);
    }
  },
);
